import React from 'react'
import { useTranslation } from 'react-i18next';
import { useKato } from '../../../../contexts/kato.context';
import { useParams } from 'react-router-dom';
import { useShared } from '../../../../contexts/shared.context';
import Card from '../../../../components/card/card.component';
import classes from './styles.module.scss';
import { IPopulationDemandStatCounts } from '../../../../types/kato.types';
import { getLang } from '../../../../helpers/utils';

const baseClass = 'population-demand-card';
const translationKey = 'cards.population-demand-card';

const headers: (keyof IPopulationDemandStatCounts)[] = [
    'normalConstructionCount',
    'constructionRepairRequirementCount',
    'newConstructionRequirementCount',
    'notProvidedCount'
]

const PopulationDemandCard = () => {
    const { t } = useTranslation();
    const { populationDemandStatsCounts } = useKato().katoGeneralInfo
    const { kato } = useParams<{ kato: string }>();
    const { selectedInfoYear } = useShared();

    const onClick = () => {
        window.open(`https://aktobe.csi.kz/#/snp?region=${kato}&year=${selectedInfoYear}`, '_blank');
    };

    if (!populationDemandStatsCounts) return null;
    return (
        <Card
            title={t(`${translationKey}.title`)}
            subtitle={t(`${translationKey}.subtitle`)}
            onClick={onClick}>
            <div className={classes[baseClass]}>
                <div className={classes[`${baseClass}__table`]}>
                    <table>
                        <thead>
                            <tr>
                                <th></th>
                                {headers.map(header => (
                                    <th key={header}>
                                        <div className={classes[`${baseClass}__header`]}>
                                            <span> {t(`${translationKey}.${header}`)}</span>
                                        </div>
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {populationDemandStatsCounts.map((item, index) => (
                                <tr key={index}>
                                    {
                                        [`name${getLang()}` as 'nameRu' | 'nameKz', ...headers].map((header) => (
                                            <td key={header}>
                                                <div className={classes[`${baseClass}__cell`]}>
                                                    {item[header] ?? 0}
                                                </div>
                                            </td>
                                        ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </Card>
    )
}

export default PopulationDemandCard